import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../interfaces/User';
import { LanguageCode, Page } from '@gbr-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly httpClient = inject(HttpClient);

    public getMe(): Observable<User> {
        return this.httpClient.get<User>(`${environment.apiUrl}/me`);
    }

    public patchMe(language: LanguageCode): Observable<User> {
        return this.httpClient.patch<User>(`${environment.apiUrl}/me`, { language });
    }

    public getWorkerCouncilMembers(groups: string[], page: number, search?: string): Observable<Page<User>> {
        const params = {
            groups: groups.join(','),
            page: page.toString()
        } as {
            groups: string;
            page: string;
            search?: string;
        };

        if (search) {
            params['search'] = search;
        }

        return this.httpClient.get<Page<User>>(`${environment.apiUrl}/workers-council-groups/users`, { params });
    }
}
